// @ts-ignore
import React from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";
import SimpleImageTextSide from "@/patterns/wpl/simple-image-text-side/src";

const jsmScalingSectionStyle = css({
    // Note: Existing issue, need to update this file quickly to fix a broken page
    // Context: https://atlassian.slack.com/archives/C02V61RM39Q/p1723210373590779
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".jsm-scaling-section": {
        "overflow": "hidden",
        "padding": "56px 0",
        "backgroundColor": wacToken("color.extended.blue1000"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".content-block": {
            margin: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "h2": {
            lineHeight: 1.333333,
            marginBlockEnd: "14px",
            fontWeight: 500
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "p": {
            fontSize: "1.25rem",
            lineHeight: 1.4
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "h2, p": {
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            color: wacToken("color.neutral.light0")
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".contentBlock-linkFlex": {
            marginBlockEnd: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "img": {
            alignSelf: "start"
        }
    },
    [media.below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".jsm-scaling-section": {
            padding: "56px 0",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            h2: {
                fontSize: "1.5rem"
            }
        }
    },
    [media.above.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".jsm-scaling-section": {
            padding: "56px 0",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            h2: {
                fontSize: "2.25rem",
                marginBlockEnd: "14px"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            img: {
                paddingInlineStart: 0
            }
        }
    },
    [media.above.md]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".jsm-scaling-section": {
            "padding": "96px 0",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "h2": {
                fontSize: "2.25rem",
                lineHeight: 1.333333,
                marginBlockEnd: "24px"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".content-block": {
                padding: "0 16px",
                marginInlineEnd: "15%"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "img": {
                margin: 0,
                paddingInlineEnd: "15%"
            }
        }
    }
});

const ScalingSection = () => {
    const intl = useIntl();

    return (
        <section css={jsmScalingSectionStyle}>
            <SimpleImageTextSide
                headerText={intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.scalingHeader",
                    defaultMessage: "Jira Service Management scales with you"
                })}
                bodyText={intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.scalingBody",
                    defaultMessage:
                        "Whether you’re part of a small team or a big enterprise,  we have a plan for you. Choose only the features you need."
                })}
                ctaProps={{
                    buttonProps: {
                        text: intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.scalingCTA",
                            defaultMessage: "Discover plans"
                        }),

                        url: useLocalizedHref(
                            "/software/jira/service-management/pricing"
                        ),
                        color: "yellow",
                        className: "jsm-scaling-section-cta",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "linkButton",
                            "data-event": "clicked",
                            "data-label-english": "Discover plans",
                            "data-product-key": "jiraServiceManagement",
                            "data-label": intl.formatMessage({
                                id: "JiraServiceManagementPageTemplate.scalingCTA",
                                defaultMessage: "Discover plans"
                            })
                        }
                    }
                }}
                backgroundColor={wacToken("color.extended.blue1000")}
                margin="0 0"
                className={"jsm-scaling-section"}
                imageLink="https://wac-cdn.atlassian.com/dam/jcr:56da3ff6-b5f2-4b64-815f-5e51867f59de/jsm-features.svg?cdnVersion=1286"
                imageAltText={intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.awardImageAltText",
                    defaultMessage:
                        "Jira Service management features as listed: SLA Management, Chat, Self Service, Queues, Automation, Assets, Atlassian Analytics, Deployment setting, incident investigation, and dynamic forms"
                })}
            />
        </section>
    );
};

export default ScalingSection;
